import { FocusCard } from "/react4xp/components/cards/FocusCard";

export default (props) => <FocusCard {...props} />;
